<template>
  <div class="discount-tag" v-if="!!rate">{{ `会员${rate}折` }}</div>
</template>

<script>
export default {
  name: 'discount-tag',
  props: {
    rate: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="less" scoped>
.discount-tag {
  font-size: 10px;
  color: #FFDB97;
  background: #30353c;
  border-radius: 2px;
  padding: 0 3px;
  height: 14px;
  display: inline-flex;
  align-items: center;
}
</style>
